import { defineComponent as _defineComponent } from 'vue'
import { PropType, toRefs } from 'vue';
import { User } from '@/models/User';
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerUserSelectItem',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true
  },
  isSelected: Boolean
},
  setup(__props) {

const props = __props;



const { user } = toRefs(props);

const { displayName } = useUser(user);


return { __sfc: true,props, user, displayName, BCXAvatar }
}

})